import React, { useEffect, useState, useRef, createElement } from 'react';
import { Ticket, X, User, Mail, Phone, Globe, AlertTriangle, Brain, Rocket, CheckCircle, Clock, Target, Users, Shield, ArrowRight } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+39',
  country: 'Italia'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function WebinarJuevesNewPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [fbclid, setFbclid] = useState('');
  const [ipAddress, setIpAddress] = useState('');
  const [fbp, setFbp] = useState('');
  const [fbc, setFbc] = useState('');
  const [utmParams, setUtmParams] = useState<Record<string, string>>({});
  const [userAgent, setUserAgent] = useState('');
  const [pageReferrer, setPageReferrer] = useState('');
  const [landingPageUrl, setLandingPageUrl] = useState('');
  const nameInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const areaCodeRef = useRef<HTMLSelectElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Function to get next Thursday date with formatted month
  const getNextThursday = () => {
    const now = new Date();
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay(); // 0 = Sunday, 4 = Thursday
    const currentHour = estTime.getHours();
    let daysUntilThursday = 0;
    if (currentDay === 4) {
      if (currentHour >= 19) {
        daysUntilThursday = 7;
      } else {
        daysUntilThursday = 0;
      }
    } else if (currentDay < 4) {
      daysUntilThursday = 4 - currentDay;
    } else {
      daysUntilThursday = 7 - currentDay + 4;
    }
    const nextThursday = new Date(estTime);
    nextThursday.setDate(estTime.getDate() + daysUntilThursday);
    const day = nextThursday.getDate();
    const month = nextThursday.toLocaleString('es-ES', {
      month: 'long'
    }).toUpperCase();
    return `${month} ${day}`;
  };
  useEffect(() => {
    // === FULL TRACKING SUITE ===
    setLandingPageUrl(window.location.href);
    setPageReferrer(document.referrer || '');
    setUserAgent(navigator.userAgent || '');
    const urlParams = new URLSearchParams(window.location.search);
    const fbclidParam = urlParams.get('fbclid');
    if (fbclidParam) {
      setFbclid(fbclidParam);
      const fbcCookie = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1];
      setFbc(fbcCookie || `fb.1.${Date.now()}.${fbclidParam}`);
    } else {
      const fbcCookie = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1];
      if (fbcCookie) setFbc(fbcCookie);
    }
    const utms: Record<string, string> = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
    utmKeys.forEach(key => {
      const val = urlParams.get(key);
      if (val) utms[key] = val;
    });
    const adParams = ['gclid', 'gbraid', 'wbraid', 'ttclid', 'ScCid', 'msclkid'];
    adParams.forEach(key => {
      const val = urlParams.get(key);
      if (val) utms[key] = val;
    });
    setUtmParams(utms);
    const readFbpCookie = () => {
      const fbpCookie = document.cookie.split('; ').find(row => row.startsWith('_fbp='))?.split('=')[1];
      if (fbpCookie) {
        setFbp(fbpCookie);
      }
    };
    readFbpCookie();
    const fbpTimer = setTimeout(readFbpCookie, 2000);
    fetch('https://api.ipify.org?format=json').then(res => res.json()).then(data => {
      if (data.ip) {
        setIpAddress(data.ip);
      }
    }).catch(err => console.warn('Could not fetch IP address:', err));
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    return () => clearTimeout(fbpTimer);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const domName = nameInputRef.current?.value?.trim() || '';
    const domEmail = emailInputRef.current?.value?.trim() || '';
    const domPhone = phoneInputRef.current?.value?.replace(/\D/g, '').trim() || '';
    const domAreaCode = areaCodeRef.current?.value || '+1';
    const finalName = domName || name.trim() || (formData.get('name') as string)?.trim() || '';
    const finalEmail = domEmail || email.trim() || (formData.get('email') as string)?.trim() || '';
    const finalPhone = domPhone || phone.trim() || (formData.get('phone') as string)?.replace(/\D/g, '').trim() || '';
    const finalAreaCode = domAreaCode || areaCode || formData.get('areaCode') as string || '+1';
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu número de teléfono');
      return;
    }
    if (!smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/PLACEHOLDER_WEBINAR_JUEVES_NEW';
      const payload = {
        name: finalName,
        email: finalEmail,
        phone: `${finalAreaCode}${finalPhone}`,
        first_name: finalName.split(' ')[0],
        last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
        full_name: finalName,
        phoneNumber: finalPhone,
        phone_number: finalPhone,
        fullPhone: `${finalAreaCode}${finalPhone}`,
        full_phone: `${finalAreaCode}${finalPhone}`,
        areaCode: finalAreaCode,
        area_code: finalAreaCode,
        contact_name: finalName,
        contactName: finalName,
        source: location.pathname,
        page_path: location.pathname,
        fbclid: fbclid || '',
        fbc: fbc || '',
        fbp: fbp || '',
        ip_address: ipAddress || '',
        ipAddress: ipAddress || '',
        user_agent: userAgent || '',
        userAgent: userAgent || '',
        utm_source: utmParams.utm_source || '',
        utm_medium: utmParams.utm_medium || '',
        utm_campaign: utmParams.utm_campaign || '',
        utm_content: utmParams.utm_content || '',
        utm_term: utmParams.utm_term || '',
        utm_id: utmParams.utm_id || '',
        gclid: utmParams.gclid || '',
        gbraid: utmParams.gbraid || '',
        wbraid: utmParams.wbraid || '',
        ttclid: utmParams.ttclid || '',
        msclkid: utmParams.msclkid || '',
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: landingPageUrl || window.location.href,
        action_source: 'website',
        page_referrer: pageReferrer || '',
        landing_page: landingPageUrl || window.location.href
      };
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      navigate('/thank-you');
    } catch (error) {
      console.error('Error submitting form:', error);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden selection:bg-[#00f7fc]/30 selection:text-[#00f7fc]" data-id="element-4987">
      <noscript data-id="element-4988">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4989" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[600px] md:h-[800px] z-0 opacity-40" data-id="element-4990">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-4991" />
      </div>

      <main className="relative z-10 w-full" data-id="element-4992">
        {/* SECTION 1: ABOVE THE FOLD */}
        <section className="pt-8 md:pt-16 pb-16 md:pb-24 px-4 flex flex-col items-center text-center max-w-5xl mx-auto" data-id="element-4993">
          <div className="w-full max-w-[320px] md:max-w-[500px] lg:max-w-[600px] mb-6 animate-fade-in-up" data-id="element-4994">
            <img src="https://cdn.magicpatterns.com/uploads/rZjvDAnMDLXJQX7she8uyT/Banner_48h_Cash_Machine_2.png" alt="48H AI Cash Machine" className="w-full h-auto drop-shadow-2xl" data-id="element-4995" />
          </div>

          <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-6" data-id="element-4996">
            <span className="relative flex h-3 w-3" data-id="element-4997">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-4998"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#00f7fc]" data-id="element-4999"></span>
            </span>
            <span className="text-sm font-bold text-[#00f7fc] uppercase tracking-wide" data-id="element-5000">
              Masterclass Gratuita
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black uppercase leading-tight md:leading-tight mb-6" data-id="element-5001">
            El Sistema de IA para Lanzar un Producto Digital Rentable en{' '}
            <span className="text-[#00f7fc]" data-id="element-5002">48 Horas</span>
          </h1>

          <p className="text-lg md:text-2xl text-gray-300 mb-10 max-w-4xl leading-relaxed" data-id="element-5003">
            Descubre cómo dejar de improvisar y usar un sistema que elige el
            producto, crea la oferta y construye la máquina de ventas por ti.
            Incluso si empiezas desde cero, sin experiencia y sin seguidores.
          </p>

          <div className="w-full max-w-2xl mb-8" data-id="element-5004">
            <button onClick={() => setShowRegisterModal(true)} className="group relative w-full bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black rounded-full py-4 px-6 md:py-6 md:px-10 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5005">
              <div className="flex flex-col items-center justify-center" data-id="element-5006">
                <div className="flex items-center gap-3 mb-1" data-id="element-5007">
                  <Ticket className="w-8 h-8 md:w-10 md:h-10 text-black fill-black/10" data-id="element-5008" />
                  <span className="text-xl md:text-3xl font-black uppercase tracking-tight" data-id="element-5009">
                    Sí, ¡Quiero Reservar Mi Lugar Gratis!
                  </span>
                </div>
              </div>
              <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none" data-id="element-5010">
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-5011" />
              </div>
            </button>
          </div>

          <div className="flex flex-col items-center gap-4 text-gray-400" data-id="element-5012">
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-5013">
              <Clock className="w-5 h-5 text-[#00f7fc]" data-id="element-5014" />
              <span data-id="element-5015">
                El próximo workshop en vivo comienza el:{' '}
                <strong className="text-white" data-id="element-5016">
                  {getNextThursday()} | 7PM EST
                </strong>
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-5017">
              <Users className="w-4 h-4 text-[#FDB931]" data-id="element-5018" />
              <span data-id="element-5019">
                Únete a más de <strong data-id="element-5020">10,000+</strong> emprendedores que ya
                descubrieron el sistema HEYLLOYD.
              </span>
            </div>
          </div>
        </section>

        {/* SECTION 2: EL PROBLEMA */}
        <section className="py-16 md:py-24 px-4 bg-gray-900/50 border-y border-gray-800" data-id="element-5021">
          <div className="max-w-4xl mx-auto" data-id="element-5022">
            <div className="text-center mb-12" data-id="element-5023">
              <AlertTriangle className="w-12 h-12 text-[#FDB931] mx-auto mb-6" data-id="element-5024" />
              <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" data-id="element-5025">
                Si Estás Cansado de Probarlo Todo Sin Resultados Sostenibles,{' '}
                <span className="text-[#FDB931]" data-id="element-5026">No Estás Solo.</span>
              </h2>
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-5027">
                Has visto los videos, comprado los cursos y quizás hasta lanzado
                anuncios. Dropshipping, Amazon FBA, marketing de afiliados... la
                lista sigue. Pero la realidad es que sigues atrapado en el mismo
                lugar: trabajando demasiado por muy pocos resultados, abrumado
                por la cantidad de decisiones que tienes que tomar y sin un
                ingreso predecible que te dé la libertad que buscas. El problema
                no es tu esfuerzo. Es que estás jugando un juego sin tener las
                reglas claras.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5028">
              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5029">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5030">
                  <Brain className="w-6 h-6 text-red-500" data-id="element-5031" />
                </div>
                <div data-id="element-5032">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5033">
                    ¿Paralizado por el análisis?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5034">
                    Tantas opciones de nicho y producto que al final no eliges
                    ninguna.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5035">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5036">
                  <Target className="w-6 h-6 text-red-500" data-id="element-5037" />
                </div>
                <div data-id="element-5038">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5039">
                    ¿Cansado de crear contenido?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5040">
                    Sientes que eres un esclavo del algoritmo de Instagram o
                    TikTok sin ver un retorno claro.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5041">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5042">
                  <Globe className="w-6 h-6 text-red-500" data-id="element-5043" />
                </div>
                <div data-id="element-5044">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5045">
                    ¿Frustrado con la tecnología?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5046">
                    Las plataformas, los embudos y las automatizaciones se
                    sienten como un laberinto imposible.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5047">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5048">
                  <Rocket className="w-6 h-6 text-red-500" data-id="element-5049" />
                </div>
                <div data-id="element-5050">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5051">
                    ¿Quemando dinero en anuncios?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5052">
                    Inviertes sin una estrategia clara, esperando un golpe de
                    suerte que nunca llega.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4 md:col-span-2" data-id="element-5053">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5054">
                  <User className="w-6 h-6 text-red-500" data-id="element-5055" />
                </div>
                <div data-id="element-5056">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5057">
                    ¿Sientes que empezaste tarde?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5058">
                    Crees que no tener experiencia o miles de seguidores es una
                    desventaja insuperable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: LA SOLUCIÓN */}
        <section className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-5059">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00f7fc]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-5060"></div>

          <div className="max-w-4xl mx-auto relative z-10" data-id="element-5061">
            <div className="text-center mb-16" data-id="element-5062">
              <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-5063">
                La Nueva Forma de Construir un Negocio Digital:{' '}
                <span className="text-[#00f7fc]" data-id="element-5064">
                  Deja que un Sistema de IA Decida Por Ti
                </span>
              </h2>
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-5065">
                Imagina por un segundo si pudieras eliminar el 90% de las
                decisiones que te frenan. ¿Y si un sistema pudiera analizar el
                mercado por ti, decirte exactamente qué producto vender, crear
                ese producto, escribir el copy de ventas y hasta generar los
                anuncios? Eso ya no es el futuro. Es HEYLLOYD, el primer sistema
                operativo de decisiones para emprendedores digitales. En esta
                Masterclass, te mostraremos en vivo cómo funciona.
              </p>
            </div>

            <div className="space-y-6" data-id="element-5066">
              {[{
              title: 'Claridad Absoluta',
              desc: 'Descubre productos de alta demanda que el mercado ya quiere comprar, eliminando las adivinanzas.'
            }, {
              title: 'Velocidad de Implementación',
              desc: 'Lanza un producto digital completo (ebook, curso, etc.) en menos de 48 horas, no en meses.'
            }, {
              title: 'Conversión sin Esfuerzo',
              desc: 'Genera páginas de venta y cartas de venta persuasivas con IA, aunque no sepas nada de copywriting.'
            }, {
              title: 'Marketing Automatizado',
              desc: 'Crea los guiones, imágenes y copys para tus anuncios con un clic, listos para lanzar y validar.'
            }, {
              title: 'La Ventaja del Novato',
              desc: 'Aprende por qué empezar desde cero es tu mayor fortaleza cuando tienes un sistema probado que seguir.'
            }].map((item, i) => <div key={i} className="bg-gray-900/80 border border-[#00f7fc]/20 p-6 rounded-2xl flex items-center gap-6 hover:border-[#00f7fc]/50 transition-colors" data-id="element-5067">
                  <div className="bg-[#00f7fc]/10 p-4 rounded-full shrink-0" data-id="element-5068">
                    <CheckCircle className="w-8 h-8 text-[#00f7fc]" data-id="element-5069" />
                  </div>
                  <div data-id="element-5070">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-5071">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-5072">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECTION 4: ¿QUÉ APRENDERÁS? */}
        <section className="py-16 md:py-24 px-4 bg-gray-900/50 border-y border-gray-800" data-id="element-5073">
          <div className="max-w-4xl mx-auto" data-id="element-5074">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-5075">
              Esto es lo que Descubrirás en la{' '}
              <span className="text-[#FDB931]" data-id="element-5076">AI Masterclass en Vivo:</span>
            </h2>

            <div className="bg-black border border-gray-800 rounded-2xl overflow-hidden mb-12" data-id="element-5077">
              <div className="grid grid-cols-1 md:grid-cols-3 bg-gray-800/50 border-b border-gray-800 p-4" data-id="element-5078">
                <div className="font-bold text-gray-400 uppercase tracking-wide text-sm md:col-span-1" data-id="element-5079">
                  Módulo
                </div>
                <div className="font-bold text-gray-400 uppercase tracking-wide text-sm md:col-span-2 hidden md:block" data-id="element-5080">
                  Contenido
                </div>
              </div>

              <div className="divide-y divide-gray-800" data-id="element-5081">
                {[{
                mod: 'El Framework HEYLLOYD',
                desc: 'El sistema paso a paso que usan nuestros estudiantes para pasar de cero a ventas en tiempo récord.'
              }, {
                mod: 'DEMO EN VIVO',
                desc: 'Verás con tus propios ojos cómo creamos y lanzamos un producto desde cero usando IA en menos de 30 minutos.'
              }, {
                mod: 'El Secreto de la Validación Rápida',
                desc: 'Cómo usar micro-presupuestos en anuncios ($10/día) para validar tu oferta y obtener tus primeras ventas.'
              }, {
                mod: 'El Fin de la Improvisación',
                desc: 'Cómo tomar decisiones basadas en datos, no en emociones, para escalar de forma predecible.'
              }, {
                mod: 'Sesión de Q&A',
                desc: 'Al final, responderé todas tus preguntas para que salgas con una claridad total sobre tus siguientes pasos.'
              }].map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-3 p-6 gap-4 items-center hover:bg-gray-900/50 transition-colors" data-id="element-5082">
                    <div className="font-bold text-lg text-[#00f7fc] md:col-span-1" data-id="element-5083">
                      {row.mod}
                    </div>
                    <div className="text-gray-300 md:col-span-2 leading-relaxed" data-id="element-5084">
                      {row.desc}
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="text-center" data-id="element-5085">
              <button onClick={() => setShowRegisterModal(true)} className="inline-flex items-center gap-3 bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] hover:from-[#00d7dc] hover:to-[#00b8bc] text-black font-black uppercase tracking-wide rounded-full py-4 px-10 shadow-[0_0_30px_rgba(0,247,252,0.3)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5086">
                <span data-id="element-5087">¡Reserva Mi Lugar Ahora!</span>
                <ArrowRight className="w-5 h-5" data-id="element-5088" />
              </button>
            </div>
          </div>
        </section>

        {/* SECTION 5: SOBRE EL PRESENTADOR */}
        <section className="py-16 md:py-24 px-4" data-id="element-5089">
          <div className="max-w-5xl mx-auto" data-id="element-5090">
            <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-10" data-id="element-5091">
              <div className="w-full md:w-1/3 shrink-0" data-id="element-5092">
                <div className="relative" data-id="element-5093">
                  <div className="absolute -inset-4 bg-gradient-to-br from-[#00f7fc] to-[#FDB931] rounded-full blur-2xl opacity-20" data-id="element-5094"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Gabriel Beltrán" className="relative w-64 h-64 md:w-full md:h-auto aspect-square object-cover rounded-full border-4 border-gray-800 mx-auto" data-id="element-5095" />
                </div>
              </div>

              <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-5096">
                <div className="inline-flex items-center gap-2 bg-gray-800 rounded-full px-4 py-1.5 mb-4" data-id="element-5097">
                  <Shield className="w-4 h-4 text-[#FDB931]" data-id="element-5098" />
                  <span className="text-xs font-bold text-gray-300 uppercase tracking-wider" data-id="element-5099">
                    Tu Instructor
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-5100">
                  Presentado por:{' '}
                  <span className="text-[#00f7fc]" data-id="element-5101">Gabriel Beltrán</span>
                </h2>
                <p className="text-gray-300 text-lg leading-relaxed mb-8" data-id="element-5102">
                  Después de pasar de vivir de cheque en cheque a generar más de
                  $50 millones de dólares en línea, Gabriel descubrió que el
                  secreto del éxito no era trabajar más duro, sino construir
                  sistemas que tomaran mejores decisiones. Su obsesión se
                  convirtió en crear un sistema que permitiera a cualquier
                  persona, sin importar su experiencia, lanzar un negocio
                  digital rentable. Así nació HEYLLOYD. Hoy, su misión es ayudar
                  a miles de emprendedores a alcanzar la libertad financiera y
                  de tiempo a través de la inteligencia artificial y los
                  productos digitales.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6: CTA FINAL */}
        <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-transparent to-[#00f7fc]/5" data-id="element-5103">
          <div className="max-w-3xl mx-auto text-center" data-id="element-5104">
            <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-5105">
              Tu Negocio Digital Está a un Sistema de Distancia.{' '}
              <span className="text-[#FDB931]" data-id="element-5106">¿Vas a Seguir Esperando?</span>
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-5107">
              Esta Masterclass es 100% gratuita, pero los cupos son limitados
              para poder interactuar con los asistentes. Si estás realmente
              comprometido con cambiar tu situación y construir un negocio real,
              no dejes pasar esta oportunidad. El momento de actuar es ahora.
            </p>

            <button onClick={() => setShowRegisterModal(true)} className="group relative w-full md:w-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black rounded-full py-5 px-10 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02] mb-6" data-id="element-5108">
              <div className="flex items-center justify-center gap-3" data-id="element-5109">
                <Ticket className="w-6 h-6" data-id="element-5110" />
                <span className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-5111">
                  Sí, Quiero el Sistema. ¡Reservar Mi Lugar Gratis!
                </span>
              </div>
            </button>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-5112">
              <Shield className="w-4 h-4" data-id="element-5113" />
              <p data-id="element-5114">
                Respetamos tu privacidad. Tu email está 100% seguro y solo lo
                usaremos para enviarte el acceso a la masterclass y
                recordatorios.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-5115" />

      {/* Registration Modal */}
      {showRegisterModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} data-id="element-5116">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(253,185,49,0.15)]" onClick={e => e.stopPropagation()} data-id="element-5117">
            <button onClick={() => setShowRegisterModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" data-id="element-5118">
              <X className="w-6 h-6" data-id="element-5119" />
            </button>

            <div className="text-center mb-6" data-id="element-5120">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-5121">
                Completa Tu Registro
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-5122">
                Ingresa tus datos para asegurar tu cupo gratuito
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-5123">
              {/* Name Input */}
              <div className="space-y-1" data-id="element-5124">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5125">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-5126">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5127">
                    <User className="h-5 w-5 text-gray-500" data-id="element-5128" />
                  </div>
                  <input ref={nameInputRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5129" />
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-1" data-id="element-5130">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5131">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-5132">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5133">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-5134" />
                  </div>
                  <input ref={emailInputRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5135" />
                </div>
              </div>

              {/* Phone Input Group */}
              <div className="space-y-1" data-id="element-5136">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5137">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-5138">
                  <div className="relative w-1/3" data-id="element-5139">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-5140">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-5141" />
                    </div>
                    <select ref={areaCodeRef} name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-5142">
                      {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900" data-id="element-5143">
                          {country.code} {country.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-5144">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5145">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-5146" />
                    </div>
                    <input ref={phoneInputRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5147" />
                  </div>
                </div>
              </div>

              {/* SMS Consent Checkbox */}
              <div className="space-y-2" data-id="element-5148">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-5149">
                  <div className="relative flex-shrink-0 mt-0.5" data-id="element-5150">
                    <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-5151" />
                    <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-[#FDB931] peer-checked:border-[#FDB931] transition-all flex items-center justify-center" data-id="element-5152">
                      {smsConsent && <svg className="w-3 h-3 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-5153">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-5154" />
                        </svg>}
                    </div>
                  </div>
                  <span className="text-[10px] leading-tight text-gray-400 group-hover:text-gray-300 transition-colors" data-id="element-5155">
                    Al marcar esta casilla, acepto recibir mensajes SMS/texto
                    recurrentes de True Marketer LLC al número móvil
                    proporcionado, incluyendo actualizaciones del programa,
                    información de capacitación y mensajes de
                    marketing/promocionales, enviados mediante un sistema de
                    marcación telefónica automática/tecnología automatizada. La
                    frecuencia de los mensajes varía. Pueden aplicar tarifas de
                    mensajes y datos. Responde STOP para cancelar, HELP para
                    ayuda. El consentimiento no es una condición de compra. Ver{' '}
                    <Link to="/terms" className="text-[#FDB931] hover:text-[#FFC54D] underline" data-id="element-5156">
                      Términos
                    </Link>{' '}
                    y{' '}
                    <Link to="/privacy" className="text-[#FDB931] hover:text-[#FFC54D] underline" data-id="element-5157">
                      Política de Privacidad
                    </Link>
                    .
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] disabled:opacity-50 disabled:cursor-not-allowed text-black font-black uppercase tracking-wide rounded-xl py-4 shadow-lg hover:shadow-[#FDB931]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5158">
                {isSubmitting ? 'PROCESANDO...' : 'CONFIRMAR REGISTRO'}
              </button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-5159">
                Tus datos están 100% seguros y no compartiremos tu información.
              </p>
            </form>
          </div>
        </div>}
    </div>;
}